import {
  Address,
  ChainKey,
  ShareTokenMeta,
  TokenUid,
  TokenUidFromString,
} from "@silo/types";
import { Effect, Option, pipe } from "effect";
import { KvClientError, KvService } from "./types";
import { getShareTokenMetaMapKey } from "./keys";
import { Schema } from "@effect/schema";

export type GetShareTokenMeta = ReturnType<typeof getShareTokenMeta>;
export type GetShareTokenMetaSuccess = Effect.Effect.Success<GetShareTokenMeta>;
export type GetShareTokenMetaError = Effect.Effect.Error<GetShareTokenMeta>;
export type GetShareTokenMetaContext = Effect.Effect.Context<GetShareTokenMeta>;

export function getShareTokenMeta(
  chainKey: ChainKey,
  shareTokenAddress: Address
) {
  return Effect.gen(function* () {
    const kv = yield* KvService;

    const tokenUidString = yield* Schema.encode(TokenUidFromString)({
      chainKey,
      tokenAddress: shareTokenAddress,
    });

    const result = yield* Effect.tryPromise({
      try: async () => {
        return kv.hget(getShareTokenMetaMapKey(), tokenUidString);
      },
      catch: (cause) => new KvClientError({ cause }),
    });

    const shareTokenMeta = yield* pipe(
      result,
      Schema.decodeUnknown(Schema.NullOr(ShareTokenMeta))
    );

    const option = Option.fromNullable(shareTokenMeta);

    return option;
  });
}
